import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PostulacionesSaludService } from 'src/app/services/postulaciones-salud/postulaciones-salud.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConsultaPostulacionesService } from 'src/app/services/consulta-postulaciones/consulta-postulaciones.service';
import { ModalInfoRechazoBeneficiario } from '../common/modal-info-rechazo-beneficiario.component';
import { ModalInfoRechazoCompaniaBeneficiario } from '../common/modal-info-rechazo-compania-beneficiario.component';
import { Postulaciones } from 'src/app/models/postulaciones/postulaciones.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Usuario } from 'src/app/models/usuario/usuario.model';
import { TiposService } from 'src/app/services/tipos/tipos.service';
import { BecasService } from '../../services/becas/becas.service';
import { ReembolsosService } from 'src/app/services/reembolsos/reembolsos.service';
import Swal from 'sweetalert2';
import { DialogEditPostulacionReembolso } from './postulacion-reembolso-validar.component';
import { DialogEditPostulacionAyudaMedica } from './postulaciones-ayudamedica-validar.component';

import { Tipos } from 'src/app/models/tipos/tipos.model';
import { isNullOrUndefined } from 'util';
import { ModalInfoBeneficiario } from '../common/modal-info-beneficiario.component';
import { ModalInfoPagadaBeneficiario } from '../common/modal-info-pagada-beneficiario.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-postulaciones-salud',
  templateUrl: '../../pages/postulaciones-salud/postulaciones-salud.component.html',
  styleUrls: ['../../pages/postulaciones-salud/postulaciones-salud.component.css']
})
export class PostulacionesSaludComponent implements OnInit
{
    postulaciones: any
    postulacionesFinales: any
    postulacionSeleccionada: any

    rol: string = localStorage.getItem("rol")
    config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
    tipoPostulacion : string = "Disponibles"
    allComplete: boolean = false
    regiones: any
    estado:any
    tipoProducto: any
    tipoCategoria: any
    mostrarTipoCategoria: boolean = false
    idEjecutivo = localStorage.getItem("idUsuario")
    buscador: any =
    {
        tipoProducto:['BECA', 'ESCOLARIDAD', 'NACIMIENTO', 'MATRIMONIO', 'CATASTROFE', 'FALLECIMIENTO'],
        rut:'', region:'', fechaInicio:'', fechaFin:'', itemsPerPage: 5, currentPage:1, idSolicitud:'',tipoCategoria:'',
        estado:['INGRESADA', 'PAGADA', 'DISPONIBLE PARA PAGO', 'RECHAZADA', 'APROBADA', 'ENVIADO A COMPANIA','LIQUIDADA POR COMPANIA','RECHAZADO POR COMPANIA'],
        paginasTotal:5
    }


  
    constructor(public router: Router, public postulacionesService:PostulacionesSaludService,
                public consultaPostulacionesService: ConsultaPostulacionesService,
                private becasService: BecasService,
                private dialog: MatDialog, public reembolsoService: ReembolsosService,
                private tiposService: TiposService) { }

    ngOnInit(): void
    {
        if(this.rol == "ROLE_AFILIADO" || this.rol == "ROLE_JUBILADO") { this.postulacionesAfiliado(true) }
        else
        {


            this.postulacionesService.traeRegiones().then(regiones => this.regiones = regiones).catch(error => console.log(error))

            this.postulacionesService.traeEstados().then(estado=> this.estado = estado).catch(error => console.log(error))

            this.postulacionesDisponibles(true);

            this.postulacionesService.traeTipoProductoSalud(this.idEjecutivo).then(tipoProducto => this.tipoProducto = tipoProducto).catch(error => console.log(error))
        
            this.postulacionesService.traeTipoCategoriasSalud(this.idEjecutivo).then(tipoCategoria => this.tipoCategoria = tipoCategoria).catch(error => console.log(error))
            
            
        
        }
    }

    buscar()
    {
        this.buscador.currentPage = 1, this.config.itemsPerPage = 5
        if(this.buscador.estadoselect.length==0){
          this.openAlertDialog('Favor seleccionar al menos un estado.', 'btn-danger')
          return
        }
        if( (this.buscador.fechaInicio != '' && this.buscador.fechaFin == '')
        || (this.buscador.fechaInicio == '' && this.buscador.fechaFin != ''))
        {
            this.openAlertDialog('Favor seleccionar fecha de inicio y fecha fin.', 'btn-danger')
            return
        }else{
          let fechaInicial = this.buscador.fechaInicio.split('-')
          let fechaFinal = this.buscador.fechaFin.split('-')
          if(parseInt(fechaInicial[0] + '' + fechaInicial[1] + '' + fechaInicial[2]) >parseInt(fechaFinal[0] + '' + fechaFinal[1] + '' + fechaFinal[2])){

            this.openAlertDialog('Favor la fecha de inicio es mayor a la final.', 'btn-danger');
            this.buscador.fechaFin="";
            return
          }
        }
        if(this.tipoPostulacion == 'Disponibles'){
            this.postulacionesDisponibles(false)
        } else if (this.tipoPostulacion == 'Propias'){
            this.postulacionesAfiliado(false)
        }else {
            this.postulacionesAsignadas(false)
        }
        
    }

    postulacionesAfiliado(recarga?: boolean)
    {
        let vm = this
        vm.tipoPostulacion='Propias'
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();

        if(recarga) {vm.config.currentPage = 1, vm.buscador.currentPage = 1
          this.buscador.region = "0";
          this.buscador.estadoselect=['INGRESADA', 'PAGADA', 'DISPONIBLE PARA PAGO','EN VALIDACION', 'RECHAZADA', 'APROBADA','ANULADA','ENVIADO A COMPANIA','LIQUIDADA POR COMPANIA','RECHAZADO POR COMPANIA'];
          this.buscador.rut ='';
          this.buscador.fechaInicio='';
          this.buscador.fechaFin='';
          this.buscador.idSolicitud='';

        }

        this.buscador.estado=this.buscador.estadoselect;
        this.buscador.rut = localStorage.getItem("rutUsuario") + '-' + localStorage.getItem("dvUsuario")

        this.postulacionesService.traePostulacionesAfiliado(localStorage.getItem("username"), this.buscador).then
        (
            (postulaciones: any) =>
            {
           

                postulaciones.resultado.forEach(postulacion => { postulacion.seleccionado = false })

                vm.postulaciones = postulaciones.resultado
                vm.buscador.paginasTotal = postulaciones.resultado.length
                vm.config.currentPage = this.buscador.currentPage
                vm.config.totalItems = postulaciones.cantidadRegistros
                postulaciones.cantidadPaginasTotal=postulaciones.cantidadRegistros/postulaciones.cantidadPaginas
                
                vm.buscador.paginasTotal = postulaciones.cantidadPaginas
                this.buscador.paginasTotal= postulaciones.cantidadPaginas               
               
                
                if(this.buscador.currentPage < postulaciones.cantidadPaginasTotal){
                    this.config.itemsPerPage=postulaciones.resultado.length
                }
                  Swal.close();
            }
        )
        .catch ( error => {console.log('Se cae el trae postulaciones', error);
      Swal.close();} )
    }

    postulacionesDisponibles(recarga?: boolean)
    {

        let vm = this
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
        if(recarga) {vm.config.currentPage = 1, vm.buscador.currentPage = 1
          this.buscador.region = "0";
          //this.buscador.estadoselect=['INGRESADA', 'PAGADA', 'DISPONIBLE PARA PAGO', 'RECHAZADA', 'APROBADA'];
          this.buscador.estadoselect=['INGRESADA', 'EN VALIDACION'];
          this.buscador.rut ='';
          this.buscador.fechaInicio='';
          this.buscador.fechaFin='';
          this.buscador.idSolicitud='';

        }

        vm.tipoPostulacion = "Disponibles"
        this.buscador.estado=this.buscador.estadoselect;
        this.postulacionesService.traePostulacionesDisponibles(localStorage.getItem("username"), this.buscador).then
        (
            (postulaciones: any) =>
            {
               postulaciones.resultado.forEach(postulacion => { postulacion.seleccionado = false })

                vm.postulaciones = postulaciones.resultado
                vm.config.currentPage = this.buscador.currentPage
                vm.config.totalItems = postulaciones.cantidadRegistros
                vm.buscador.paginasTotal = postulaciones.cantidadPaginas
                this.buscador.paginasTotal= postulaciones.cantidadPaginas
                if(this.buscador.currentPage < postulaciones.cantidadPaginas){
                    this.config.itemsPerPage=postulaciones.resultado.length
                }
                Swal.close();
            }
        )
        .catch ( error =>
        {
            console.log(error)

            vm.tipoPostulacion = "Disponibles"
            vm.postulaciones = []

            vm.config.totalItems = 0
            Swal.close();
            if(error.status == 404) vm.openAlertDialog("No se han encontrado postulaciones disponibles.", "btn-dark")
        } )
    }

    postulacionesAsignadas(recargar?: boolean)
    {
        let vm = this
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
        vm.tipoPostulacion = "Asignadas"
        vm.mostrarTipoCategoria=true
        if(recargar){ this.config.currentPage = 1, this.buscador.currentPage = 1
          this.buscador.region = "0";
          this.buscador.estadoselect=['EN VALIDACION', 'DISPONIBLE PARA PAGO'];
          this.buscador.tipoProductoselect = ['REEMBOLSO','AYUDA MEDICA'];  
         
          this.buscador.rut ='';
          this.buscador.fechaInicio='';
          this.buscador.fechaFin='';
          this.buscador.idSolicitud='';
      }
        this.buscador.estado=this.buscador.estadoselect;
        this.postulacionesService.traePostulacionesAsignadas(localStorage.getItem("idUsuario"), this.buscador).then
        (
            (postulaciones: any) =>
            {
                console.log(postulaciones)

                vm.postulaciones = postulaciones.resultado
            
                vm.config.currentPage = this.buscador.currentPage
                postulaciones.cantidadPaginasTotal=postulaciones.cantidadRegistros/postulaciones.cantidadPaginas
                
                vm.config.totalItems = postulaciones.cantidadRegistros
                vm.buscador.paginasTotal = postulaciones.cantidadPaginas
                this.buscador.paginasTotal= postulaciones.cantidadPaginas
                if(this.buscador.currentPage < postulaciones.cantidadPaginasTotal){
                    this.config.itemsPerPage=postulaciones.resultado.length
                }
             
                Swal.close();
            }
        )
        .catch ( error =>
        {
            console.log(error)
            Swal.close();
            vm.postulaciones = []
            vm.config.totalItems = 0
        } )
    }

    asignarSeleccionados()
    {
        let postulacionesSeleccionadas: any = []

        this.postulaciones.filter( pos => pos.seleccionado ).forEach(pos => {
          
            if(pos.estado=='INGRESADA'){
                postulacionesSeleccionadas.push({id:pos.posId })
            }
           
        })

        let vm = this

        if(postulacionesSeleccionadas.length == 0)
        {
            this.openAlertDialog("Debe seleccionar al menos una postulación.", "btn-danger")
            return
        }
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();

        this.postulacionesService.asignaPostulacion(postulacionesSeleccionadas, this.idEjecutivo).then
        (
            () =>
            {          
              if (vm.buscador.paginasTotal == postulacionesSeleccionadas.length && vm.buscador.currentPage>1){
                vm.buscador.currentPage = vm.buscador.currentPage-1;
                  vm.config.currentPage = this.buscador.currentPage
              }
              console.log("vm.buscador.currentPaged"+vm.buscador.currentPage)
                vm.openAlertDialog('La postulación se ha asignado exitosamente.', 'btn-success')
                vm.postulacionesDisponibles(false)
                Swal.close();
            }
        )
        .catch ( error =>
        {
             Swal.close();
            console.log(error)
            vm.openAlertDialog('Las postulaciones no se ha podido asignar.', 'btn-danger')
        } )
    }

    asignaPostulacion(idPostulacion: any)
    {

      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();
        let postulacion = [{id:idPostulacion}]
        let vm = this

        this.postulacionesService.asignaPostulacion(postulacion, this.idEjecutivo).then
        (
            () =>
            {
              if (vm.buscador.paginasTotal == 1 && vm.buscador.currentPage>1){

                vm.buscador.currentPage = vm.buscador.currentPage-1;
                  vm.config.currentPage = this.buscador.currentPage
              }
                vm.openAlertDialog('La postulación se ha asignado exitosamente.', 'btn-success')
                setTimeout(function(){
                  vm.postulacionesDisponibles(false)
                },500);
                Swal.close();
            }
        )
        .catch
        (
            error =>
            {
                Swal.close();
                console.log(error)
                vm.openAlertDialog('La postulación no se ha podido asignar.', 'btn-danger')
            }
        )
    }

    detalleBeneficiario(rutAfiliado: any)
    {
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();

        let data: any = { }

        this.postulacionesService.traeUsuario(rutAfiliado.split('-')[0]).then
        (
            (usu: any) =>
            {
                console.log(usu)

                data.nombre = usu.nombres + ' ' + usu.apellidoPaterno + ' ' + usu.apellidoMaterno
                data.telefono = usu.telefonoFijo
                data.celular = usu.telefonoMovil
                data.mail = usu.email
                data.prevision = usu.prevision
                data.beneficiarios = usu.carga
            }
        )
        .catch(error => console.log(error))
        Swal.close();
        const dialogRef = this.dialog.open(ModalInfoBeneficiario, { width: '40%', data: data })

        dialogRef.afterClosed().subscribe( () => {  })
    }

  detalleRechazoBeneficiario(idPostulacion: any)
  {
    Swal.fire({
      allowOutsideClick:false,
      icon:'info',
      text:'Cargando...'
    });
    Swal.showLoading();

      let data: any = { }

      this.consultaPostulacionesService.traeDataRechazo(idPostulacion).then
      (
          (postulacion: any) =>
          {
              console.log(postulacion)
              data.tipoRechazo=postulacion.motivoRechazo
              data.comentarioRechazo=postulacion.descripcionRechazo
           
          }
      )
      .catch(error => console.log(error))
      Swal.close();
      const dialogRef = this.dialog.open(ModalInfoRechazoBeneficiario, { width: '40%', data: data })

      dialogRef.afterClosed().subscribe( () => {  })
  }

  detalleRechazoPorCompaniaBeneficiario(idPostulacion: any)
  {
    Swal.fire({
      allowOutsideClick:false,
      icon:'info',
      text:'Cargando...'
    });
    Swal.showLoading();

      let data: any = { }

      this.consultaPostulacionesService.traeDataRechazoCompania(idPostulacion).then
      (
          (postulacion: any) =>
          {
           
              data.tipoRechazo=postulacion.motivoRechazo
              data.comentarioRechazo=postulacion.comentarioRechazo
              data.descripcionRechazo=postulacion.descripcionRechazo
              data.motivoRechazo=postulacion.motivoRechazo
              data.estado=postulacion.estado
              data.numDocumento=postulacion.numDocumento
              data.fechaRespuesta=postulacion.fechaRespuesta
          }
      )
      .catch(error => console.log(error))
      Swal.close();
      const dialogRef = this.dialog.open(ModalInfoRechazoCompaniaBeneficiario, { width: '40%', data: data })

      dialogRef.afterClosed().subscribe( () => {  })
  }

  detalleSolicitudPagada(idPostulacion: any)
  {
    Swal.fire({
      allowOutsideClick:false,
      icon:'info',
      text:'Cargando...'
    });
    Swal.showLoading();

      let data: any = { }

      this.consultaPostulacionesService.traeDataPagada(idPostulacion).then
      (
          (postulacion: any) =>
          {
              console.log(postulacion)
              data.idGrupo=postulacion.id
              data.fechaPago=postulacion.fechaRespuesta
           
          }
      )
      .catch(error => console.log(error))
      Swal.close();
      const dialogRef = this.dialog.open(ModalInfoPagadaBeneficiario, { width: '40%', data: data })

      dialogRef.afterClosed().subscribe( () => {  })
  }


    openDialogAnular(idPostulacion: any, rut: any)
    {   
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        const dialogRef = this.dialog.open(ConfirmationDialog,
        {
            data: { message: '¿Esta seguro de anular la solicitud?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe( (confirmed: boolean) =>
        {
            if (confirmed)
            {

              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
                let vm = this
            
                this.postulacionesService.cambiarEstadoPostulacion(idPostulacion, "ANULADA",idUsuarioSesion).then
                (
                    () =>
                    {
                        vm.postulacionesService.traePostulacionesDisponibles(localStorage.getItem("username"), this.buscador).then
                        (
                            (postulaciones: any) =>{ vm.postulaciones = postulaciones
                              vm.buscador.paginasTotal = postulaciones.resultado.length
                              vm.postulacionesAfiliado(false)
                          }
                          
                        )
                        .catch ( error => console.log('Se cae el trae postulaciones ', error) )

                        Swal.close();
                        vm.openAlertDialog('La postulación se ha anulado exitosamente.', 'btn-success')
                    }
                )
                .catch
                (
                    error =>
                    {

                        Swal.close();
                        console.log(error)
                        vm.openAlertDialog('La postulación no se ha podido anular.', 'btn-danger')
                    }
                )

            }
        })
    }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    openEditDialog(idPostulacion: any, nombreProducto: any, mostrarEditar?: any, disponiblePago?: any): void
    {
		 //       if(nombreProducto == 'REEMBOLSO') { this.openDialogReembolsos(idPostulacion, mostrarEditar,disponiblePago) }
		
        if(nombreProducto == 'REEMBOLSO') 
        { 
            this.openDialogReembolsos(idPostulacion, mostrarEditar,disponiblePago) 
        }else{
            this.openDialogAyudaMedica(idPostulacion, mostrarEditar,disponiblePago) 
        }
		
    }

    openDialogReembolsos(idPostulacion: any, mostrarEditar?: any,disponiblePago?:any)
    {
        let vm = this
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
        let mostrarAprobarButton=true;
        let mostrarEnviarButton=true;
        if(disponiblePago){
          mostrarAprobarButton=false;
          mostrarEnviarButton=false;
          
            if(localStorage.getItem("rol")=='ROLE_ADMINISTRADOR'){
            disponiblePago=false;
            mostrarAprobarButton=true;
            mostrarEnviarButton=true;
            }
            
        }

        this.postulacionesService.traePostulacionReembolso(idPostulacion,mostrarEditar).then
        (
            (response: any) =>
            {
                let fecha = response.reembolso.fechaDocumento.split('-')

                let data: any =
                {
                    archivos: response.archivoAdjunto,
                    idPostulacion: response.id,
                    tipoReembolso: response.reembolso.idTipo,
                    reembolsoCategoria: response.reembolso.idReembolsoCat,
                    reembolsoSubcategoria: response.reembolso.idReembolsoSubcat,
                    prevision: response.reembolso.idPrevision,
                    tipoDocumento: response.reembolso.tipoDocumento,
                    rutPrestador: response.reembolso.rutPrestador + '-' + response.reembolso.dvPrestador,
                    nDocumento: response.reembolso.numDocumento,
                    nBoleta: response.reembolso.numBoleta,
                    montoCopago: response.reembolso.montoCopago,
                    montoReembolso: response.reembolso.montoReembolso,
                    folioExterno: response.reembolso.folioExterno,
                    observacion: response.reembolso.observacion,
                    fechaDocumento: fecha[2] + '-' + fecha[1] + '-' + fecha[0],                   
                    carga: response.idUsuario ? false : true,
                    idUsuario:response.idUsuario,
                    tiposDocumento: ['BONO', 'REEMBOLSO', 'BOLETA/FACTURA/VOUCHER'],
                    deshabilitado: true,
                    presionaEditar: false,
                    mostrarEditar: mostrarEditar,
                    disponiblePago : !disponiblePago,
                    mostrarAprobarButton:mostrarAprobarButton,
                    mostrarEnviarButton:mostrarEnviarButton
                    
                }
                vm.reembolsoService.traePrevisionesDisponibles().then
                (
                    (previsiones) => {data.previsiones = previsiones;}
                )
                .catch ( error => console.log(error) )

                vm.tiposService.traeTipos(3).then
                (
                    (tipos: Tipos[]) => { if(tipos.length > 0) { data.tiposReembolso = tipos } }
                )
                .catch ( error => console.log(error) )

                vm.reembolsoService.traeCategorias(response.reembolso.idTipo).then
                (
                    categorias => { data.categorias = categorias }
                )
                .catch ( error => console.log(error) )

                vm.reembolsoService.traeSubCategorias(response.reembolso.idReembolsoCat).then
                (
                    subcategorias => { data.subcategorias = subcategorias }
                )
                .catch ( error => console.log(error) )
                this.reembolsoService.obtieneProductos().then
                (
                    productos => productos[2].parametros.map( parametro => {
                        if(parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_DOCUMENTO') {
                            data.diasDiferencia = parametro.valor
                        }
                    })
                )
                .catch ( error => console.log(error) )
                vm.reembolsoService.traePostulantes(response.rutAfiliado).then
                (
                    (usuario: Usuario) =>
                    {
                        data.email = usuario.email
                        data.nombreCompleto = usuario.nombres + ' ' + usuario.apellidoPaterno

                        if(data.carga)
                        {
                            let usuariosPostulantes: Array<Usuario> = [];

                            data.beneficiario = { id:response.idCarga, rut:'' }
                            if(usuario.carga){
                                usuario.carga.forEach(carga => {
                                    if(carga.id == response.idCarga) { data.beneficiario.rut = carga.rut }
                                    usuariosPostulantes.push(carga)
                                })
                            }
                            data.postulantes = usuariosPostulantes
                        }
                        else
                        {
                            data.beneficiario =
                            {
                                id:usuario.id,
                                rut:usuario.rut,
                                descripcion: usuario.nombres + ' ' + usuario.apellidoPaterno + ' (' + usuario.rut + '-' + usuario.dv + ')'
                            }
                        }
                          Swal.close();
                       
                        const dialogRef = vm.dialog.open(DialogEditPostulacionReembolso, {
                            width: '47%', data: data
                        })

                        dialogRef.afterClosed().subscribe( () => { if(data.recarga) { vm.postulacionesAsignadas(false) } })
                    }
                )
                .catch ( error => {console.log(error);
                  Swal.close(); })
            }
        )
        .catch ( error =>{ console.log(error);
        Swal.close();})
    }

  
    openDialogAyudaMedica(idPostulacion: any, mostrarEditar?: any, disponiblePago?: any) {
        var vm = this
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();

        let mostrarAprobarButton=true;
        let mostrarEnviarButton=true;
        if(disponiblePago){
          mostrarAprobarButton=false;
          mostrarEnviarButton=false;
          
            if(localStorage.getItem("rol")=='ROLE_ADMINISTRADOR'){
            	disponiblePago=false;
            	mostrarAprobarButton=true;
           		mostrarEnviarButton=true;
            }
            
        }
     
        this.postulacionesService.traePostulacionAyudaMedica(idPostulacion).then
            (
                (response: any) => {
                
                    let fechaInicial = response.ayudaMedicaDTO.fechaCreacion?.split('-')  
                    let documentosAyudasArray=response.ayudaMedicaDTO.documentosAyudasDTO;
                    let data: any =
                    {
                       idPostulacion: response.id,
                       idProducto: response.idProducto,
                       idEjecutivoAsignado: response.idEjecutivoAsignado,
                       estado: response.estado,
                       idCarga: response.idCarga,
                       idUsuario:response.idUsuario,
                       stringTipoEvento: response.ayudaMedicaDTO.stringTipoEvento,
                       fechaCreacion: fechaInicial[2] + '-' + fechaInicial[1] + '-' + fechaInicial[0],
                       totalPagar: response.ayudaMedicaDTO.totalPagar,
                       totalCopago: response.ayudaMedicaDTO.totalCopago,
                       tipoEvento: response.ayudaMedicaDTO.tipoEvento,
                       porcentajeRebaja: response.ayudaMedicaDTO.porcentajeRebaja,
                       observacion: response.ayudaMedicaDTO.observacion,
                       idAyudaMedica: response.ayudaMedicaDTO.idAyudaMedica,
                       deshabilitado: true,
                       deshabilitadoObs: true,
                       presionaEditar: false,
                       mostrarEditar: mostrarEditar,
                       disponiblePago : !disponiblePago,
                       mostrarAprobarButton:mostrarAprobarButton,
                       mostrarEnviarButton:mostrarEnviarButton,
                       documentosAyuda:documentosAyudasArray                     
                    }
                    
                 
                    vm.reembolsoService.traePostulantes(response.rutAfiliado).then
                        (
                            (usuario: Usuario) => {
                                data.email = usuario.email
                                data.nombreCompleto = usuario.nombres + ' ' + usuario.apellidoPaterno
                               
                                if (data.idCarga) {
                                    let usuariosPostulantes: Array<Usuario> = []

                                    usuario.carga.forEach(carga => usuariosPostulantes.push(carga))
                                    data.mostrarTitularCarga = true;
                                    data.postulantes = usuariosPostulantes
                                    data.beneficiario = usuario.nombres + ' ' + usuario.apellidoPaterno + ' (' + usuario.rut + '-' + usuario.dv + ')'
                                    data.datoBeneficiario = response.nombreCompleto + ' (' + response.rutBeneficiario + ')'
                                }
                                else {
                                    data.mostrarTitularCarga = false;
                                    data.beneficiario = usuario.nombres + ' ' + usuario.apellidoPaterno + ' (' + usuario.rut + '-' + usuario.dv + ')'
                                    data.datoBeneficiario = usuario.nombres + ' ' + usuario.apellidoPaterno + ' (' + usuario.rut + '-' + usuario.dv + ')'
                                }
                          
                                this.becasService.obtieneProductos().then
                                    (
                                        productos => productos[2].parametros.map(parametro => {
                                            if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_DOCUMENTO') {
                                                data.diasDiferencia = parametro.valor
                                            }
                                        })
                                    )
                            
                                const dialogRef = vm.dialog.open(DialogEditPostulacionAyudaMedica, { width: '53%', data: data })
                                Swal.close();
                                dialogRef.afterClosed().subscribe(() => { if (data.recarga) { vm.postulacionesAsignadas(false) } })
                                       
                            }
                        )
                        .catch(error => {
                            console.log('SE CAE TRAE POSTULANTES ', error)
                            Swal.close();
                        })
                }
            )
            .catch(error => {
                console.log("Se cae el trae postulacion AyudaMedica", error)
                Swal.close();
            })
    }
   
    verArchivo(postulacionId: any)
    {
        let vm = this

        this.postulacionesService.traeArchivos(postulacionId).then
        (
            (archivos: any) =>
            {                
                archivos.forEach( archivo => {
                    var fileURL=`${environment.urlBlob}/${archivo.url}`             
                    window.open(fileURL);
                })  
               
            }
        )
        .catch
        (
            error =>
            {
                console.log(error)
                vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
            }
        )
    }

    someComplete(): boolean
    {
        if (isNullOrUndefined(this.postulaciones?.seleccionado)) { return false }

        return this.postulaciones.filter(p => p.seleccionado).length > 0 && !this.allComplete
    }

    setAll(seleccionado: boolean)
    {
        this.allComplete = seleccionado

        if (this.postulaciones == null) { return }

        this.postulaciones.forEach(pos => { pos.seleccionado = seleccionado })
    }

    updateAllComplete()
    {
        this.allComplete =  this.postulaciones != null && this.postulaciones
                            .slice(this.config.indexInicial, this.config.indexMaximo)
                            .every(p => p.seleccionado)
    }

    pageChanged(event: any)
    {
        this.config.currentPage = event , this.buscador.currentPage = event
  
        if(this.tipoPostulacion == 'Disponibles'){

          this.postulacionesDisponibles(false)
        }

        if(this.tipoPostulacion == 'Asignadas'){

          this.postulacionesAsignadas(false)
        }


        if (this.tipoPostulacion =='Propias'){

            this.postulacionesAfiliado(false)
        }



        this.config.indexInicial = ( (this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = ( this.config.currentPage * this.config.itemsPerPage )

        //this.updateAllComplete()
    }

    cambiaCantidadRegistros()
    {
        this.config.indexInicial = 0, this.config.indexMaximo = this.config.itemsPerPage, this.config.currentPage = 1
    }

 
    muestraCategorias()
    {   
        this.mostrarTipoCategoria=false
        for (let i = 0; i < this.buscador.tipoProductoselect.length; i++) {            
            if (this.buscador.tipoProductoselect[i] == 'REEMBOLSO') {
                this.mostrarTipoCategoria=true
            } 
        }
    }
}
